import { Component, AfterContentInit, Input, ContentChildren, QueryList } from '@angular/core';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';

@Component({
  selector: 'breadcrumb-trail',
  templateUrl: './breadcrumb-trail.component.html',
  styleUrls: ['./breadcrumb-trail.component.scss']
})
export class BreadcrumbTrailComponent implements AfterContentInit {

  @Input()
  spacing: number;

  @Input()
  height: number;

  @ContentChildren(BreadcrumbComponent)
  breadcrumbs: QueryList<BreadcrumbComponent>;

  private _totalWidth: number;
  set totalWidth(totalWidth: number) {
    this._totalWidth = totalWidth;
  }

  get totalWidth() {
    return this._totalWidth;
  }

  setupBreadCrumbs(list: QueryList<BreadcrumbComponent>) {
    let calculatedTotalWidth = 0.0;
    list.forEach((b) => {
      b.left = calculatedTotalWidth;
      b.height = this.height;
      b.isFirst = b == list.first;
      b.isLast = b == list.last;

      calculatedTotalWidth += b.totalWidth;
      if (!b.isLast) {
        calculatedTotalWidth += this.spacing;
      }
    });

    this.totalWidth = calculatedTotalWidth;
  }

  ngAfterContentInit() {
    this.setupBreadCrumbs(this.breadcrumbs);
    this.breadcrumbs.changes.subscribe(list => this.setupBreadCrumbs(list));
  }
}
